import React from 'react';
import SupportTierCard from './SupportTierCard';
import type { SupportPlan } from '../../../types/support';

interface SupportTiersProps {
  plans: Array<SupportPlan & { featured?: boolean }>;
}

const SupportTiers: React.FC<SupportTiersProps> = ({ plans }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {plans.map((plan) => (
        <SupportTierCard
          key={plan.name}
          {...plan}
        />
      ))}
    </div>
  );
};

export default SupportTiers;